import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'
import { connect } from 'react-redux'

import Editor from 'components/Editors/Editor'
import NotePlaceholder from 'components/Editors/NoteEditor/Placeholder'
import { provideEditorValue } from '@slite/editor'
import { actions as UIActions } from 'data/ui'
import RoutesHelper, { getAbsolutePath } from 'helpers/RoutesHelper'

import createPublicNotePlugins from 'components/Editors/plugins/createPublicNotePlugins'
import { selectors as ConfigSelectors } from 'data/config'
import isMobile from 'is-mobile'
import { NoteTitle } from './Layout'

class PublicNotesShowRichTextEditor extends React.PureComponent {
  static propTypes = {
    noteTitle: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onEditorRef: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    isEditable: PropTypes.bool.isRequired,
    publicChannelId: PropTypes.string,
  }

  constructor(props) {
    super(props)

    const { createInfoToasterMessage, iframelyApiKey, isEditable } = props
    this.plugins = createPublicNotePlugins({
      iframelyApiKey,
      createInfoToasterMessage,
      getFullNotePath: this.getFullNotePath,
      isEditable,
      publicChannelId: this.props.publicChannelId,
    })
  }

  getFullNotePath = noteId => {
    const { channelId } = this.props.note
    const relativePath = RoutesHelper.noteChannelShow({ channelId, noteId })
    return getAbsolutePath(relativePath)
  }

  render() {
    const {
      noteTitle,
      value,
      onChange,
      onError,
      onEditorRef,
      isEditable,
    } = this.props

    if (!value) {
      return <NotePlaceholder />
    }

    return (
      <React.Fragment>
        <NoteTitle>{noteTitle}</NoteTitle>
        <Editor
          value={value}
          placeholder="This doc is empty"
          plugins={this.plugins}
          noteEditor
          readOnly={!isEditable || isMobile()}
          onChange={onChange}
          onError={onError}
          onEditorRef={onEditorRef}
        />
      </React.Fragment>
    )
  }
}

export default compose(
  pure,
  provideEditorValue(),
  connect(
    state => ({
      iframelyApiKey: ConfigSelectors.getIframelyApiKey(state),
    }),
    {
      ...UIActions,
    }
  )
)(PublicNotesShowRichTextEditor)
